<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<ul class="page-internal-tabs">
    <li *ngFor="let subType of subTypes; let i = index;" tabindex="{{tabIndex + (i + 1)}}">
        <a *ngIf="hideUrl" routerLink="/{{tab.type | lowercase }}/{{subType | lowercase}}/{{tab.id}}" skipLocationChange [attr.tabindex]="(tab.subType != subType)? '-1': (tabLevel + i)" [ngClass]="{selected:(tab.subType === subType)}">
      {{subType}}
      </a>
        <a *ngIf="!hideUrl" routerLink="/{{tab.type | lowercase }}/{{subType | lowercase}}/{{tab.id}}" [attr.tabindex]="(tab.subType != subType)? '-1': (tabLevel + i)" [ngClass]="{selected:(tab.subType === subType)}">
        {{subType}}
        </a>
    </li>
</ul>